import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  container: {
    paddingTop: spacing(),
    paddingBottom: spacing(),
    paddingLeft: spacing(0.75),
    paddingRight: spacing(0.75),

    [breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      paddingTop: spacing(.5),
      paddingBottom: spacing(.5),
    }
  },
  icon: {
    display: 'block',
    marginBottom: spacing(.5),

    [breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },
  title: {
    whiteSpace: 'normal',
    lineHeight: 1
  },
  subContainer: {
    width: '100%'
  }
}));
